import { useId } from 'react';

/** Static brand ornament; never indicates authentication or device activity. */
export default function AccessGeometry() {
  const id = `access-geometry-${useId().replace(/:/g, '')}`;
  return <svg className="access-geometry" viewBox="0 0 640 900" fill="none" aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id={id} x1="60" y1="80" x2="580" y2="800" gradientUnits="userSpaceOnUse">
        <stop className="ribbon-stop-cyan" /><stop offset=".55" className="ribbon-stop-blue" /><stop offset="1" className="ribbon-stop-violet" />
      </linearGradient>
    </defs>
    <g stroke={`url(#${id})`} strokeWidth="1.25">
      <circle cx="570" cy="190" r="130" /><circle cx="570" cy="190" r="160" opacity=".45" />
      <rect x="-65" y="620" width="190" height="190" rx="30" transform="rotate(-22 30 715)" />
      <rect x="-45" y="640" width="150" height="150" rx="24" transform="rotate(-22 30 715)" opacity=".45" />
      <path d="M420 690h72m-36-36v72M125 170h36m-18-18v36" opacity=".7" />
    </g>
  </svg>;
}
